@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins/_breakpoints";

.NavbarButton {
  display: none;
  width: auto;
  height: 40px;
  background-color: transparent;
  font-family: "SpyscapeTwo webfont", sans-serif;
  line-height: 2.17;
  font-size: 12px;
  font-weight: 300;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: background-color 0.3s linear;
  color: white;
  padding: 10px;

  @include media-breakpoint-up(md) {
    display: flex;
  }

  &:hover {
    color: #4ecef7;
  }
}

.secondary {
  width: 136px;
  background-color: #0f0f0f;
  padding: 0;
  margin-left: 10px;

  &:hover {
    background-color: #383838;
    color: #4ecef7;
  }
}

.primary {
  width: 136px;
  background-color: #4ecef7;
  color: black;
  padding: 0;
  margin-left: 10px;

  &:hover {
    background-color: #1292cc;
    color: white;
  }
}

.alternate {
  color: rgba(0, 34, 102, 1);
}

.venue {
  background: black;
  color: #1292cc;
  border: 1px solid #1292cc;
  display: flex;
  flex: 1;
  justify-content: space-between;
  padding-left: 10px;

  &:last-child {
    border-top: none;
  }
}

.hideTabletPortraitAndMobile {
  @media (max-width: 768px) {
    display: none;
  }
}
